"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  return {
    Tooltip: {
      '& .tooltip-inner': {
        textAlign: 'left'
      }
    },
    OverlayTrigger: {
      flex: 1
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map